import { Button } from '@/components/ui/button';
import { DashboardPaginationProps } from '../types';

export const DashboardPagination = ({
    currentPage,
    totalPages,
    onPageChange,
    totalReports,
    itemsPerPage,
    itemLabel = 'laudos',
}: DashboardPaginationProps) => {
    if (totalPages <= 1) return null;

    // Both counters are built as one string and marked `translate="no"`. Split
    // across sibling text nodes they are the shape Chrome's translator rewrites,
    // which leaves React removing nodes it no longer owns — see the removeChild
    // crash this component used to throw on /patients and the dashboard.
    const firstItem = (currentPage - 1) * itemsPerPage + 1;
    const lastItem = Math.min(currentPage * itemsPerPage, totalReports);
    const rangeLabel = `Exibindo ${firstItem} a ${lastItem} de ${totalReports} ${itemLabel}`;
    const pageLabel = `Página ${currentPage} de ${totalPages}`;

    return (
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-sm tabular-nums text-muted-foreground" translate="no">
                {rangeLabel}
            </div>
            <div className="flex items-center justify-between gap-2 sm:hidden">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                >
                    Anterior
                </Button>
                <span
                    className="text-sm font-medium tabular-nums text-muted-foreground"
                    translate="no"
                >
                    {pageLabel}
                </span>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                >
                    Próximo
                </Button>
            </div>
            <div className="hidden flex-wrap gap-2 sm:flex">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                >
                    Anterior
                </Button>
                <div className="flex gap-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <Button
                            key={page}
                            variant={currentPage === page ? 'default' : 'surface'}
                            size="sm"
                            onClick={() => onPageChange(page)}
                            className="min-w-8 tabular-nums"
                        >
                            {page}
                        </Button>
                    ))}
                </div>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                >
                    Próximo
                </Button>
            </div>
        </div>
    );
};
